import styled from 'styled-components';

const Text = styled.div`
    text-align: center;
    color: ${(props) => props.primaryDark};
    font-weight: 500;
    padding: 2em 15%;
`;

export { Text };
